import { Header, Segment, Image as SemanticUiImage } from 'semantic-ui-react';
import FixedElementOnScroll from '../../../../../components/fixedElementOnScroll';
import { ROLES } from '../../../../../constnats/user';
import AuthService from '../../../../../service/auth';
import { getPeriod, getYearsComponent } from '../../../../../utils/reportResourceUtil';
import { useRowsBoundingBoxes } from '../../stores/boundingBoxesStore';
import { useImageStoreHighlightedCoordinates, useImageStoreImage } from '../../stores/imageStore';
import { useRowsImportCandidates } from '../../stores/metadataStore';
import { Coordinate, S3KeyType } from '../../types';
import ImageHighlighter from '../imageHighlighter';
import './resource.styles.css';

type ResourceProps = {
    s3Key: S3KeyType;
};

function Resource({ s3Key }: ResourceProps) {
    const image = useImageStoreImage();
    const coordinates = useImageStoreHighlightedCoordinates();
    const rowsImportCandidates = useRowsImportCandidates();
    const rowsBoundingBoxes = useRowsBoundingBoxes(rowsImportCandidates);

    const primaryCoord = {
        top: coordinates?.top ?? 0,
        height: coordinates?.height ?? 0,
        left: coordinates?.left ?? 0,
        width: coordinates?.width ?? 0,
        primary: true,
    };

    const highlightedCoordinates: Coordinate[] = [
        primaryCoord,
        /**
         * Problem:
         * - Some cells do not have the same top coordinates as other cells even if they are in the same row
         * - This causes incorrect filtering out of the currently primary coordinate of the import candidates
         * 
         * Solution:
         * - Even though the cells have different top coordinates despite them being in the same row the differences
         * - are very small (in the thousands or tens of thousands decimal places) by rounding them up to the second 
         * - decimal place we avoid the problem with same row cell having different top values
         */
        ...rowsBoundingBoxes.filter((box) => box.top.toFixed(2) !== primaryCoord.top.toFixed(2)),
    ];

    return (
        <div className="full-height flex flex-column">
            <Header as="h3">Resource</Header>
            <div>
                <p>
                    {getYearsComponent(s3Key)} <b>Period: </b>
                    {getPeriod(s3Key)}
                </p>
                {AuthService.hasGlobalRole(ROLES.ADMIN) && (
                    <>
                        <b>Full Path: </b>
                        {s3Key}
                        <br />
                    </>
                )}
            </div>
            <div className="flex-grow-1">
                <FixedElementOnScroll>
                    <Segment className="overflow--auto">
                        <div className="resource__image-container">
                            <ImageHighlighter coordinates={highlightedCoordinates}>
                                {image && <SemanticUiImage src={image.src} fluid />}
                            </ImageHighlighter>
                        </div>
                    </Segment>
                </FixedElementOnScroll>
            </div>
        </div>
    );
}

export default Resource;
